<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* 全局重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: #0f1115;
  color: #e0e0e0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
  background-color: #0f1115;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #1a1d24;
}

::-webkit-scrollbar-thumb {
  background: #3a3f4b;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #4a5060;
}

/* 链接样式 */
a {
  color: #63a278;
  text-decoration: none;
  transition: color 0.25s ease;
}

a:hover {
  color: #7ab992;
}

/* 选中文本样式 */
::selection {
  background-color: rgba(99, 162, 120, 0.3);
  color: #ffffff;
}

/* Element UI 深色主题覆盖 */
.el-loading-mask {
  background-color: rgba(15, 17, 21, 0.9) !important;
}

.el-loading-spinner .el-loading-text {
  color: #9ca3af !important;
}

.el-loading-spinner .path {
  stroke: #63a278 !important;
}
</style>
